<template>
  <div id="vehicleorderTemplate">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Vehicle Order Form</div>
          <div class="btn-groups">
            <button type="button" class="btn btn-tertiary" v-on:click="print()">
              <i class="fp-print"> </i> Print
            </button>
            <a type="button" class="btn btn-tertiary" v-on:click="downloadPdf($event)">
              <i class="fp-download"> </i> Download
            </a>
            <button type="button" class="btn btn-tertiary" v-on:click="backBtn()">
              <i class="fp-back"> </i> Back
            </button>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content vehicle-order-preview">
            <div class="bg-white">
              <div class="order-view-table" id="vehicle_order_content">

              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

import LoadingContent from "@/components/LoadingContent.vue";
import {commonMixins} from '../../mixins/commonMixins';

Vue.component("loading-content", LoadingContent);

export default {
  name: "CustomerOrderFormPreview",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Vehicle Order Form Preview | " + process.env.COPYRIGHT_NAME
  },
  components: {
    appFooter: () => import('@/components/Footer')
  },
  mixins: [commonMixins],
  data: () => ({
    loading: false,
    permissions: [],
    cantAccessPage: "",
    orderId: 0,
    path: "",
    filePath: '',

  }),
  watch: {
    permissions: function (permission) {
      var self = this;
      permission.forEach(function (permissions) {
        if (permissions.name === 'ev_list_vehicle_order') {
          self.cantAccessPage = true;
        }
      });
      if (self.cantAccessPage === '') {
        self.cantAccessPage = false;
      }
    },
  },
  mounted: function () {
    var self = this;
    self.orderId = this.$route.params.id;
    self.getPermissions();
    self.previewOrder();
    self.path = process.env.API + "/images/logo.png";
  },
  methods: {
    backBtn() {
      var self = this;
      self.$router.push("/vehicle-order/list");
    },
    downloadPdf(event) {
      event.preventDefault();
      var self = this;
      self.loading = true;
      if(self.filePath === ''){
        $.ajax({
          url: process.env.ROOT_API + "/pdf-filepath/" + self.orderId,
          type: "GET",
          crossDomain: true,
          headers: {
            'Accept': 'application/json',
            "Access-Control-Allow-Origin": '*',
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            "Cache-Control": "no-cache"
          },
          data: {},
          dataType: "json",
          success: function (data) {
            self.loading = false;
            self.filePath = data.content;
            self.getDocumentPath(0,self.filePath,'');
          },
          error: function (jqXHR, exception) {

            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, false);
          }
        });
      }else{
        self.getDocumentPath(0,self.filePath,'');
      }

    },
    previewOrder() {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/vehicle-order-form/preview-pdf/" + self.orderId,
        type: "GET",
        crossDomain: true,
        headers: {
          'Accept': 'application/json',
          "Access-Control-Allow-Origin": '*',
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
          "Cache-Control": "no-cache"
        },
        data: {},
        dataType: "html",
        success: function (data) {
          self.loading = false;
          setTimeout(function () {
            $("#vehicle_order_content").html(data);
          }, 300);
        },
        error: function (jqXHR, exception) {

          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false);
        }
      });
    },
    print() {
      var self = this;
      self.loading = true;
      var content = document.getElementById('vehicle_order_content').innerHTML;
      var link = window.open(content, '_blank');
      link.document.write(content);
      link.document.close();
      self.loading = false;
      link.print();
      link.close();

    }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/asset/CustomerOrderFormPreview.vue